import { CanActivate, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthApi } from '@features/login/data-access/auth-api';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedGuard implements CanActivate {
  constructor(
    private authenticationService: AuthApi,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authenticationService.checkAuthentication().pipe(
      map((res) => {
        if (!res.authenticated) {
          this.authenticationService.logout();
          return this.router.parseUrl('/login');
        }
        return true;
      }),
      catchError(() => {
        this.authenticationService.logout();
        return of(this.router.parseUrl('/login'));
      })
    );
  }
}